import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export const FreeLimitBanner = () => {
  const { L } = useApp();
  const { workspace } = useAuth();
  const [u, setU] = useState(null);
  useEffect(() => { if (workspace) api.get("/usage", { params: { workspace_id: workspace.id } }).then((r) => setU(r.data)); }, [workspace]);
  if (!u) return null;
  if (u.plan.key !== "free") {
    const admin = ["owner", "admin"].includes(workspace.role);
    const pct = u.minutes_quota ? Math.round((u.minutes_used / u.minutes_quota) * 100) : 0;
    if (u.minutes_left >= 1 && pct < 80) return null;
    if (u.minutes_left >= 1) return (
      <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900" data-testid="quota-warning-banner">
        <span>{L(`Anda telah guna ${pct}% kuota minit kitaran ini (baki ${u.minutes_left} minit).`, `You've used ${pct}% of this cycle's minutes (${u.minutes_left} min left).`)} {!admin && L("Hubungi admin untuk tambah kuota.", "Ask an admin to add quota.")}</span>
        {admin && <Link to="/app/billing#topup" className="rounded-xl bg-amber-500 px-4 py-2 font-semibold text-white hover:bg-amber-600" data-testid="quota-warning-topup-btn">{L("Tambah kuota", "Add quota")}</Link>}
      </div>
    );
    return (
      <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-red-300 bg-red-50 p-4 text-sm text-red-900" data-testid="quota-full-banner">
        <span>{admin ? L("Kuota minit kitaran ini telah habis. Tambah kuota untuk terus merakam dan memuat naik.", "This cycle's minutes are used up. Add quota to keep recording and uploading.")
          : L("Kuota pasukan penuh — minta admin tambah kuota.", "Team quota is full — ask an admin to add quota.")}</span>
        {admin && <Link to="/app/billing#topup" className="rounded-xl bg-red-600 px-4 py-2 font-semibold text-white hover:bg-red-700" data-testid="quota-full-topup-btn">{L("Tambah kuota", "Add quota")}</Link>}
      </div>
    );
  }
  const used = (u.free_used ?? 0) >= (u.plan.lifetime_transcriptions || 1);
  return (
    <div className={`mt-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border p-4 text-sm ${used ? "border-amber-300 bg-amber-50 text-amber-900" : "border-violet-200 bg-violet-50 text-violet-900"}`} data-testid={used ? "free-limit-reached" : "free-limit-info"}>
      <span className="flex items-start gap-2"><Sparkles size={16} className="mt-0.5 shrink-0" />
        {used
          ? L("Anda telah menggunakan 1 transkripsi percuma. Naik taraf (mulai Lite RM19.90/bulan) untuk terus merakam, menjana Minit Rasmi, Nota Kuliah, Laporan & Temubual.", "You've used your 1 free transcription. Upgrade (from Lite RM19.90/month) to keep recording and generate Official Minutes, Lecture Notes, Reports & Interviews.")
          : L("Pelan Percuma: 1 transkripsi (maks. 30 minit). Dokumen AI & eksport mulai pelan Lite; bot pada Pro.", "Free plan: 1 transcription (max 30 min). AI documents & export from Lite; bot on Pro.")}
      </span>
      <Link to="/app/billing" className="rounded-xl bg-violet-600 px-4 py-2 font-semibold text-white hover:bg-violet-700" data-testid="free-limit-upgrade-btn">{L("Naik taraf", "Upgrade")}</Link>
    </div>
  );
};
